import React from "react";
import {
  Form,
  FormCheck,
  FormControl,
} from "react-bootstrap";
import { ETipoCampo, IPersonalizacao } from "./Personalizacoes";

export default function PersonalizacaoDetalhe({
  personalizacoes,
}: {
  personalizacoes: IPersonalizacao[];
}) {
  function renderCampo(
    personalizacao: IPersonalizacao
  ) {
    switch (
      personalizacao.tipocampo_id
    ) {
      case ETipoCampo.texto:
        return (
          <FormControl
            disabled
            placeholder="Texto"
          />
        );

      case ETipoCampo.texto_multilinha:
        return (
          <FormControl
            as="textarea"
            rows={4}
            disabled
            placeholder="Texto longo"
          />
        );

      case ETipoCampo.selecao:
        return (
          <Form.Select>
            <option>
              Selecione...
            </option>

            {personalizacao.opcoes?.map(
              (opcao, index) => (
                <option
                  key={
                    opcao.id ??
                    index
                  }
                >
                  {opcao.nome}
                </option>
              )
            )}
          </Form.Select>
        );

      case ETipoCampo.selecao_multipla:
        console.log(personalizacao.opcoes)
        return (
          <>
            {personalizacao.opcoes?.map(
              (opcao, index) => (
                <FormCheck
                  disabled
                  key={
                    opcao.id ??
                    index
                  }
                  type="checkbox"
                  label={opcao.nome}
                />
              )
            )}
          </>
        );

      case ETipoCampo.data:
        return (
          <FormControl
            type="date"
            disabled
          />
        );

      case ETipoCampo.booleano:
        return (
          <FormCheck
            type="switch"
            disabled
            label=""
          />
        );

      case ETipoCampo.intervalo_data:
        return (
          <div className="d-flex gap-2">
            <FormControl
              type="date"
              disabled
            />

            <FormControl
              type="date"
              disabled
            />
          </div>
        );

      default:
        return null;
    }
  }

  if (
    !personalizacoes ||
    personalizacoes.length === 0
  ) {
    return (
      <div className="text-muted">
        Nenhuma personalização cadastrada.
      </div>
    );
  }

  return (
    <>
      {personalizacoes.map(
        (personalizacao) => (
          <Form.Group
            key={personalizacao.id}
            className="mb-3"
          >
            <Form.Label>
              {personalizacao.nome}

              {personalizacao.obrigatorio && (
                <span className="text-danger">
                  {" "}
                  *
                </span>
              )}
            </Form.Label>

            {renderCampo(
              personalizacao
            )}
          </Form.Group>
        )
      )}
    </>
  );
}